define('OutSystems/ClientRuntime/modules/Storage/StorageObject',["require", "exports", "./StorageEnvironment", "./StorageNaming", "./StorageType"], function (require, exports, StorageEnvironment_1, StorageNaming_1, StorageType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CACHE_NO_VALUE = Object.freeze(Object());
    var StorageObject = (function () {
        function StorageObject(storageType, key, defaultValue, getModuleName) {
            this.storageType = storageType;
            this.key = key;
            this.defaultValue = defaultValue;
            this.getModuleName = function () { return (0, StorageNaming_1.getDefaultStorageNamespace)(); };
            this.clearCache();
            if (getModuleName) {
                this.getModuleName = getModuleName;
            }
        }
        StorageObject.prototype.get = function () {
            return this.getValueForModule(this.getModuleName());
        };
        StorageObject.prototype.set = function (value) {
            this.setValueForModule(this.getModuleName(), value);
        };
        StorageObject.prototype.remove = function () {
            this.removeValueForModule(this.getModuleName());
        };
        StorageObject.prototype.isDefined = function () {
            return this.hasValueForModule(this.getModuleName());
        };
        StorageObject.prototype.getStorageKeyForModule = function (moduleName) {
            return StorageNaming_1.OS_STORAGE_PREFIX + moduleName + "$" + this.key;
        };
        Object.defineProperty(StorageObject.prototype, "storage", {
            get: function () {
                return this.storageType === StorageType_1.default.Persistent ? (0, StorageEnvironment_1.getPersistentStorage)() : (0, StorageEnvironment_1.getSessionStorage)();
            },
            enumerable: false,
            configurable: true
        });
        StorageObject.prototype.getValueForModule = function (moduleName) {
            if (this.cachedValue === CACHE_NO_VALUE) {
                this.cachedValue = this.getValueForModuleFromStorage(moduleName);
            }
            return this.cachedValue;
        };
        StorageObject.prototype.getValueForModuleFromStorage = function (moduleName) {
            var value = this.storage.getItem(this.getStorageKeyForModule(moduleName));
            if (value === null) {
                return this.defaultValue;
            }
            return value === "undefined" || value === undefined ? undefined : JSON.parse(value);
        };
        StorageObject.prototype.hasValueForModule = function (moduleName) {
            var value = this.storage.getItem(this.getStorageKeyForModule(moduleName));
            return value !== null && value !== undefined && value !== "undefined";
        };
        StorageObject.prototype.setValueForModule = function (moduleName, value) {
            var storageKey = this.getStorageKeyForModule(moduleName);
            var stringValue = JSON.stringify(value);
            var storageObject = this.storage;
            if (!storageObject || !storageObject.setItem) {
                throw Error("The storage object for " + this.key + " is invalid.");
            }
            try {
                storageObject.setItem(storageKey, stringValue);
                this.cachedValue = value;
            }
            catch (error) {
                if ((0, StorageEnvironment_1.tryExpandStorage)(this.storageType)) {
                    this.storage.setItem(storageKey, stringValue);
                }
                else {
                    throw error;
                }
            }
        };
        StorageObject.prototype.removeValueForModule = function (moduleName) {
            this.storage.removeItem(this.getStorageKeyForModule(moduleName));
            this.clearCache();
        };
        StorageObject.prototype.clearCache = function () {
            this.cachedValue = CACHE_NO_VALUE;
        };
        return StorageObject;
    }());
    exports.default = StorageObject;
});
//# sourceMappingURL=StorageObject.js.map;
